import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Clock, MapPin } from 'lucide-react';
import logo from '../assest/foundationlogo.jpeg';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };
const handleNavigation = (link) => {
  setIsMenuOpen(false);

  if (link.isRoute) {
    navigate(link.href);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  if (location.pathname !== '/') {
    navigate('/', {
      state: {
        scrollTo: link.href,
      },
    });
  } else {
    scrollToSection(link.href);
  }
};
  const navLinks = [
        { name: 'About Us', href: 'about' },
    { name: 'Services', href: 'services' },

/*     { name: 'c', href: 'camps' }, */
    { name: 'Camps', href: '/camp-details', isRoute: true },
        { name: 'Contact', href: 'contact' },
  ];

  const goRegister = () => {
    setIsMenuOpen(false);
    navigate('/OrphanageSupport');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 w-full z-50 transition-all duration-300">

      {/* Top Bar */}
      <div className="hidden lg:block md:block bg-primary text-white py-2 px-8">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-sm font-medium">
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-2">
              <Phone size={14} /> +91 98765 43210
            </span>
            <span className="flex items-center gap-2 border-l border-teal-600 pl-6">
              <Clock size={14} /> Mon - Sat: 9:00 AM - 8:00 PM
            </span>
          </div>

          <div className="flex items-center gap-4">
            <span className="flex items-center gap-2">
              <MapPin size={14} /> Vijayawada, India
            </span>

            <button
              onClick={goRegister}
              className="bg-white text-primary py-1 px-4 rounded-lg font-bold text-sm"
            >
              OrphanageSupport
            </button>
          </div>
        </div>
      </div>

      {/* Main Nav */}
      <nav className={`bg-white transition-all duration-300 ${isScrolled ? 'py-3 shadow-lg' : 'py-5 shadow-sm'}`}>
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">

            {/* Logo */}
            <div
              onClick={() => {
                navigate('/');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="flex items-center gap-3 cursor-pointer"
            >
              <img src={logo} alt="Logo" className="w-18 h-12 object-contain" />
              <div>
                <h1 className="text-center font-black text-lg uppercase leading-tight">
  Dr. Sridhar Oral <br />
  <span>Health Foundation</span>
</h1>
                {/* <p className="text-xs text-primary font-bold">Foundation & Hospital</p> */}
              </div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex 2xl:gap-6 xl:gap-6 md:gap-4 ">
              <button
                onClick={() => {
                  navigate('/');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="font-bold text-sm uppercase"
              >
                Home
              </button>

             {navLinks.map((link) => (
  <button
    key={link.name}
onClick={() => handleNavigation(link)}
    className="font-bold text-sm uppercase"
  >
    {link.name}
  </button>
))}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`fixed top-0 right-0 h-full w-80 bg-white shadow-xl z-[60] transform transition-transform duration-300 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <div className="p-6">

{/* Header */}
<div className="flex justify-between items-center mb-8">
  <div
    onClick={() => {
      setIsMenuOpen(false);
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }}
    className="cursor-pointer"
  >
    <img
      src={logo}
      alt="Logo"
      className="h-12 w-auto object-contain"
    />
  </div>

  <button onClick={() => setIsMenuOpen(false)}>
    <X size={20} />
  </button>
</div>

            {/* Links */}
            <div className="flex flex-col gap-5 ">

              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  navigate('/');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="text-xl font-bold"
              >
                Home
              </button>

{navLinks.map((link) => (
  <button
    key={link.name}
onClick={() => handleNavigation(link)}
    className="text-xl font-bold"
  >
    {link.name}
  </button>
))}

              {/* ✅ Registration added here */}
              <button
                onClick={goRegister}
                className="mt-6 bg-primary text-white py-3 rounded-xl font-bold"
              >
                OrphanageSupport
              </button>
              
            </div>
          </div>
        </div>

        {/* Overlay */}
        {isMenuOpen && (
          <div
            className="fixed inset-0 bg-black/40 z-[50] md:hidden"
            onClick={() => setIsMenuOpen(false)}
          />
        )}
      </nav>
    </header>
  );
};

export default Header;